function importFromDir(pageName) {
    return () =>
        import(`../pages/Import/${pageName}.vue`).then(
            (m) => m.default || m,
        );
}
function importFromComponentDir(dir, pageName) {
    return () =>
        import(`../pages/Import/ImportProgress/${pageName}.vue`).then(
            (m) => m.default || m,
        );
}

export default [
    {
        path: "/import",
        name: "import",
        component: importFromDir("Index"),
        meta: {
            title: "Import",
        },
    },
];
